// extracted by mini-css-extract-plugin
export default {"lightPurple":"Button_lightPurple__3BWuR","purple":"Button_purple__TnbXh","indigo":"Button_indigo__DI8jC","bgWhite":"Button_bgWhite__TC5-V"};